module.exports = __webpack_public_path__ + "img/astral-txt_17.1c42f984.svg";